export interface Testimonial {
  id: string;
  name: string;
  city: string;
  service: string;
  quote: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 'maria-kissimmee',
    name: 'Maria G.',
    city: 'Kissimmee, FL',
    service: 'Pool Resurfacing',
    quote:
      "Our pool was stained and rough after almost 20 years. The Innova team explained everything before they started, kept us updated every step of the way, and the new finish looks amazing. Our kids don't want to get out of the water.",
  },
  {
    id: 'david-winter-garden',
    name: 'David R.',
    city: 'Winter Garden, FL',
    service: 'Tile & Coping',
    quote:
      'We had loose coping and old tile that made the whole backyard look dated. They showed up when they said they would, cleaned up every day, and the new tile completely changed the look of the pool.',
  },
  {
    id: 'jennifer-orlando',
    name: 'Jennifer & Mark T.',
    city: 'Orlando, FL',
    service: 'Full Pool Renovation',
    quote:
      'We got estimates from a few companies, and Innova was the clearest about what our pool needed and what it would cost. New finish, tile, and a paver deck. It feels like a brand-new backyard.',
  },
];
